import React, {Component} from "react";
import {
  Row,
  Col,
  Panel,
  OverlayTrigger,
  Badge,
  Tooltip as TooltipB,
  Button,
  FormGroup,
  FormControl,
  Radio,
  InputGroup,
  Modal,
  Table,
  Popover
}                         from "react-bootstrap";
import { Link }           from "react-router-dom";
import Select             from "react-select";
import                         "react-select/dist/react-select.css";
import Slider             from "rc-slider";
import Tooltip            from "rc-tooltip";
import                         "rc-slider/assets/index.css";
import                         "rc-tooltip/assets/bootstrap.css";
import DateTime           from "react-datetime";
import                         "style/react-datetime.css";
import moment             from "moment";
import Dropzone           from "react-dropzone";
import axios              from "axios";
import {
  ToastContainer,
  toast
}                         from "react-toastify";
import                         "react-toastify/dist/ReactToastify.css";

import {
  NOTIFICATION_SET_VALUE
}                         from "actions/const";

import {
  IS_VALID
}                         from "utils";

import saveTrail          from "../../utils/saveTrail";

import style              from "./style.css";
import ic_calendar        from "../../assets/image/ic_calendar.svg";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class Notification extends Component {
  constructor (props) {
    super(props);

    this.submitPush = this.submitPush.bind(this);
    this.accessible = this.accessible.bind(this);
  }

  componentDidMount() {
		// this.liveQueries = []
		// var tableNames = ['Notifications']
		// tableNames.map((name) => {
		// 	this.liveQueries[name] = new Parse.Query(name)
		// 	this.liveQueries[name].sub = this.liveQueries[name].subscribe()
		// 	this.liveQueries[name].sub.on('update', (data) => {
		// 		console.log('subscription update call')
		// 		this.getNotif()
		// 	})
		// 	this.liveQueries[name].sub.on('create', (data) => {
		// 		console.log('subscription create call')
		// 		this.getNotif()
		// 	})
		// 	this.liveQueries[name].sub.on('delete', (data) => {
		// 		console.log('subscription delete call')
		// 		this.getNotif()
		// 	})
		// });

    this.getPendingNotificationCount();
    this.getNotificationHistoryCount();
    this.getScheduledNotificationCount();
		// this.getNotif()
	}

  componentWillUnmount () {
    let { actions } = this.props;

    actions.setValue(
      NOTIFICATION_SET_VALUE,
      {
        resetState: true
      }
    );
  }

  getPendingNotificationCount () {
    let {
      actions
    } = this.props;

    let query,
        query1 = new Parse.Query("PendingNotification"),
        query2 = new Parse.Query("PendingNotification");

    query1.doesNotExist("status");

    query2.equalTo("status", "PENDING");

    query = Parse.Query.or(query1, query2);

    query.count()
    .then((count) => {
      actions.setValue(NOTIFICATION_SET_VALUE, { notifCountPending: count });
    })
    .catch((err) => {
      console.log("getPendingNotificationCount error:", err);
    });
  }

  getNotificationHistoryCount () {
    let {
      actions
    } = this.props;

    let query = new Parse.Query("Notifications");

    query
    .exists("pushTotalCount")
    .equalTo("type", "REGULAR");

    query.count()
    .then((count) => {
      actions.setValue(NOTIFICATION_SET_VALUE, { notifCount: count });
    })
    .catch((err) => {
      console.log("getNotificationHistoryCount error:", err);
    });
  }

  getScheduledNotificationCount () {
    let {
      actions
    } = this.props;

    let query = new Parse.Query("Notifications");

    query
    .exists("pushDateTime")
    .doesNotExist("pushTotalCount")
    .equalTo("type", "SCHEDULED")
    .equalTo("type", "REGULAR");

    query.count()
    .then((count) => {
      actions.setValue(NOTIFICATION_SET_VALUE, { notifCount: count });
    })
    .catch((err) => {
      console.log("getNotificationHistoryCount error:", err);
    });
  }

  // getNotif () {
  //   let {
  //     actions
  //   } = this.props;
  //
  //   let query3 = new Parse.Query("Notifications");
  //   query3.exists("pushTotalCount");
  //
  //   let query4 = new Parse.Query("Notifications");
  //   query4.equalTo("isSendPushNow", false);
  //   query4.exists("pushDateTime");
  //   query4.doesNotExist("pushTotalCount");
  //
  //   query3.equalTo("isVip", false);
  //   query4.equalTo("isVip", false);
  //
  //   Promise.all([query3.count(), query4.count()])
  //   .then(datas => {
  //     let notifCount = datas[0];
  //     let notifCountWithSchedule = datas[1];
  //
  //     let stateToUpdate = {
  //       notifCountWithSchedule,
  //       notifCount
  //     };
  //
  //     actions.setValue(NOTIFICATION_SET_VALUE, stateToUpdate);
  //   })
  //   .catch(err => {
  //     console.log(err);
  //   });
  // }

  submitPush (isConfirmation = false) {
    let {
      notif,
      actions
    } = this.props;

    let {
      sendMode,
      userType,
      cardType,
      device,
      screen,
      browser,
      specificUser,
      blacklistedUser,
      isSendNow,
      subject,
      url,
      message,
      scheduleDateTimeNotif
    } = notif;

    let {
      setValue
    } = actions;

    let currentUser = Parse.User.current();

    setValue(
      NOTIFICATION_SET_VALUE,
      {
        errors: {}
      }
    );

    const getValue = (obj) => IS_VALID(obj) && IS_VALID(obj.value) ? obj.value : '';

    // if (
    //   sendMode.value.toUpperCase() === "TEST" &&
    //   userType.value.toUpperCase() === "MEMBER" &&
    //   specificUser.length === 0
    // ) {
    //   setValue(
    //     NOTIFICATION_SET_VALUE,
    //     {
    //       errors: {
    //         specificUser: 'Specific user is required for testing.'
    //       }
    //     }
    //   );
    //
    //   return;
    // }

    if (!IS_VALID(sendMode)) {
      toast.error("Send Mode is required.");
      return;
    }

    if (!IS_VALID(userType)) {
      toast.error("User Type is required.");
      return;
    }

    if (!IS_VALID(device)) {
      toast.error("Device Type is required.");
      return;
    }

    if (!IS_VALID(subject) || !IS_VALID(subject.trim())) {
      // setValue(
      //   NOTIFICATION_SET_VALUE,
      //   {
      //     errors: {
      //       subject: 'Subject is required.'
      //     }
      //   }
      // );
      toast.error("Subject is required.");
      return;
    }

    if ((!IS_VALID(url) || !IS_VALID(url.trim())) && getValue(browser) !== "") {
      // setValue(
      //   NOTIFICATION_SET_VALUE,
      //   {
      //     errors: {
      //       url: 'Url Link is required.'
      //     }
      //   }
      // );
      toast.error("Url Link is required.");
      return;
    }

    if (!IS_VALID(message) || !IS_VALID(message.trim())) {
      // setValue(
      //   NOTIFICATION_SET_VALUE,
      //   {
      //     errors: {
      //       message: 'Message is required.'
      //     }
      //   }
      // );
      toast.error("Message is required.");
      return;
    }

    if (!isSendNow && !moment(scheduleDateTimeNotif, "MMM DD, YYYY hh:mm A", true).isValid()) {
      // setValue(
      //   NOTIFICATION_SET_VALUE,
      //   {
      //     errors: {
      //       scheduleDateTimeNotif: 'Please select a valid date and time.'
      //     }
      //   }
      // );
      toast.error("Please select a valid date and time.");
      return;
    }

    if (!isSendNow && moment(scheduleDateTimeNotif).isBefore(moment())) {
      // setValue(
      //   NOTIFICATION_SET_VALUE,
      //   {
      //     errors: {
      //       scheduleDateTimeNotif: 'Schedule should be greater than the date and time today.'
      //     }
      //   }
      // );
      toast.error("Schedule should be greater than the date and time today.");
      return;
    }

    if (isConfirmation) {
      setValue(
        NOTIFICATION_SET_VALUE,
        {
          showModalConfirmation: true
        }
      );

      return;
    }

    setValue(
      NOTIFICATION_SET_VALUE,
      {
        isSending: true,
        errors: {}
      }
    );

    let pendingNotification = new Parse.Object("PendingNotification");

    let acl = new Parse.ACL();

    acl.setPublicReadAccess(true);
    acl.setPublicWriteAccess(false);

    pendingNotification.setACL(acl);

    // OLD WILL QUERY FIRST THE SCREEN AND CARD TYPE
    // let screenQuery = new Parse.Query("Screen"),
    //     cardTypeQuery = new Parse.Query("CardType");
    //
    // screenQuery
    // .select("pageName")
    // .equalTo("objectId", getValue(screen));
    //
    // cardTypeQuery.select("name");
    //
    // if (getValue(userType) === "MEMBER") {
		// 	cardTypeQuery.equalTo("objectId", getValue(cardType));
		// }

    // Promise.all([
    //   getValue(screen) !== "" ? screenQuery.first() : "",
    //   getValue(cardType) !== "" ? cardTypeQuery.first() : ""
    // ])
    // .then(([ _screen, _cardType ]) => {
    //
    // })

    let data = {
      User: currentUser,
      sendMode: getValue(sendMode),
      userType: getValue(userType),
      device: getValue(device),
      sendType: isSendNow ? "IMMEDIATE" : "SCHEDULED",
      type: "REGULAR",

      subject: subject.trim(),
      message: message.trim()
    };

    if (!isSendNow) {
      data.pushDateTime = moment(scheduleDateTimeNotif).toDate();
    }

    if (IS_VALID(screen) && IS_VALID(screen.label)) {
      data.screen = screen.label;
    }

    if (IS_VALID(cardType) && Array.isArray(cardType)) {
      data.cardTypes = cardType.map(({ label }) => label);
    }

    if (IS_VALID(browser)) {
      data.browser = getValue(browser);
    }

    if (IS_VALID(url) && IS_VALID(url.trim())) {
      data.url = url.trim();
    }

    if (IS_VALID(specificUser) && Array.isArray(specificUser)) {
      data.specificUsers = specificUser.map((item) => item.value);
    }

    if (IS_VALID(blacklistedUser) && Array.isArray(blacklistedUser)) {
      data.blacklistedUsers = blacklistedUser.map((item) => item.value);
    }

    pendingNotification.set(data);

    let dirtyKeys = pendingNotification.dirtyKeys();

    let changesObject = {};

    for (let key of dirtyKeys) {
      if (key === "User") {
        changesObject[key] = IS_VALID(currentUser.get("name")) ? currentUser.get("name") : currentUser.get("username");
      } else if (key === "specificUsers" || key === "blacklistedUsers") {
        changesObject[key] = pendingNotification.get(key).toString();
      } else if (key === "pushDateTime") {
        changesObject[key] = moment(pendingNotification.get(key)).format();
      } else {
        changesObject[key] = pendingNotification.get(key);
      }
    }

    Promise.all([
      pendingNotification.save(),
      changesObject
    ])
    .then(([ pendingNotification, changesObject ]) => {
      changesObject.objectId = pendingNotification.id;

      toast.success("Push Notification saved.");

      setValue(
        NOTIFICATION_SET_VALUE,
        {
          isSending: false,
          showModalConfirmation: false,
          userType: {
            value: 'MEMBER',
        		label: 'MEMBER'
          },
          cardType: [],
          device: {
            value: 'ALL',
            label: 'ALL'
          },
          screen: null,
          browser: null,
          specificUser: [],
          blacklistedUser: [],
          subject: "",
          url: "",
          message: "",
          isSendNow: true,
          scheduleDateTimeNotif: moment()
        }
      );

      saveTrail("SAVE DRAFT", changesObject);
    })
    .catch((err) => {
      console.log("submitPush error:", err);

      setValue(
        NOTIFICATION_SET_VALUE,
        {
          isSending: false
        }
      );
    });

    // OLD
    //
    // let notifications = new Parse.Object("Notifications");
    //
    // let screenQuery = new Parse.Query("Screen"),
    //     cardTypeQuery = new Parse.Query("CardType");
    //
    // screenQuery.select("pageName");
    // screenQuery.equalTo("objectId", getValue(screen));
    //
    // cardTypeQuery.select("name");
    //
    // if (getValue(userType) === "member") {
		// 	cardTypeQuery.equalTo("objectId", getValue(cardType));
		// }
    //
    // Promise.all([
    //   getValue(screen) !== "" ? screenQuery.first() : "",
    //   getValue(cardType) !== "" ? cardTypeQuery.first() : ""
    // ])
    // .then(([ _screen, _cardType ]) => {
    //   if (IS_VALID(_screen)) {
    //     notifications.set("screen", _screen.get("pageName"));
    //   }
    //
    //   if (IS_VALID(_cardType)) {
    //     notifications.set("cardType", _cardType.get("name"));
    //   }
    //
    //   if (getValue(browser) !== "") {
    //     notifications.set("browser", getValue(browser));
    //   }
    //
    //   if (IS_VALID(url) && IS_VALID(url.trim())) {
    //     notifications.set("url", url.trim());
    //   }
    //
    //   if (IS_VALID(specificUser) && Array.isArray(specificUser)) {
    //     notifications.set("specificUsers", specificUser.map((item) => item.value));
    //   }
    //
    //   notifications.set("isVip", false);
    //   notifications.set("userType", getValue(userType));
    //   notifications.set("device", getValue(device));
    //   notifications.set("isSendPushNow", isSendNow);
    //   if (!isSendNow) {
    //     notifications.set("pushDateTime", scheduleDateTimeNotif.toDate());
    //   }
    //   notifications.set("message", message);
    //   notifications.set("subject", subject);
    //
    //   return Promise.all([
    //     notifications.dirtyKeys(),
    //     notifications.save()
    //   ]);
    // })
    // .then(([ changesKey, notif ]) => {
    //   setValue(
    //     NOTIFICATION_SET_VALUE,
    //     {
    //       isSending: false,
    //       userType: {
    //     		value: 'all',
    //     		label: 'ALL'
    //     	},
    //     	cardType: null,
    //       ageBracket: [35, 45],
    //       gender: null,
    //       device: {
    //     		value: 'all',
    //     		label: 'ALL'
    //     	},
    //       screen: null,
    //       browser: null,
    //       specificUser: [],
    //       subject: "",
    //     	url: "",
    //     	message: "",
    //     	isSendNow: true,
    //     	scheduleDateTimeNotif: moment()
    //     }
    //   );
    //
    //   let objectParams = {};
    //   objectParams.objectId = notif.id;
    //   for (var key of changesKey) {
		// 		objectParams[key] = notif.get(key);
		// 	}
    //
    //   saveTrail('SEND NOTIFICATION', objectParams);
    // })
    // .catch((err) => {
    //   console.log("submitPush error: ", err);
    //
    //   setValue(
    //     NOTIFICATION_SET_VALUE,
    //     {
    //       isSending: false
    //     }
    //   );
    // });
  }

  uploadSpecificUserCSVFile (csvFile, stateName) {
		let {
			notif,
			actions
		} = this.props;

    let usersState = notif[stateName];

    actions.setValue(NOTIFICATION_SET_VALUE, { isUploadingCSVFile: true });

		let fd = new FormData();

		fd.append("csvFile", csvFile);

		axios.post(
			WEB_PATH + "/MemberDetail/upload",
			fd
		)
		.then((res) => {
			let {
				data
			} = res;

      let updatedUsersState = [...usersState];

      for (let item of data) {
        if (updatedUsersState.map((item) => item.value).indexOf(item.value) === -1) {
          updatedUsersState.push({
            label: `${IS_VALID(item.memberId) ? item.memberId : ""} ${IS_VALID(item.name) ? item.name : ""}`,
            value: item.memberId
          });
        }
      }

      actions.setValue(
        NOTIFICATION_SET_VALUE,
        {
          isUploadingCSVFile: false,
          [stateName]: updatedUsersState
        }
      );
		})
		.catch((err) => {
      console.log("uploadSpecificUserCSVFile error: ", err);

      actions.setValue(
        NOTIFICATION_SET_VALUE,
        {
          isUploadingCSVFile: false
        }
      );
		});
	}

  loadOptions (input, cb, className, columnName, reduxCol) {
    const getValue = () => {
      return new Promise((resolve, reject) => {
        const isUndefined = obj => (typeof obj === "undefined" ? true : false);

        var query = new Parse.Query(className);

        if (typeof columnName === "string") {
          query.matches(columnName, ".*" + input + ".*", "i");
        } else {
          var queryArray = [];
          for (var column of columnName) {
            var query2 = new Parse.Query(className);
            query2.matches(column, input, "i");
            queryArray.push(query2);
          }
          query = Parse.Query.or(...queryArray);
        }

        switch (className) {
          case "CardType":
            query.ascending("name");
            break;
          case "Screen":
            query.ascending("pageName");
            break;
        }
        query.limit(20);
        query
        .find()
        .then(data => {
          const label = obj => {
            if (typeof columnName === "string") {
              return !isUndefined(obj.get(columnName)) ? obj.get(columnName) : "";
            } else {
              return columnName
                .map(column =>
                  !isUndefined(obj.get(column)) ? obj.get(column) : ""
                )
                .join(" ");
            }
          };

          var data = data.map(
            item =>
              (item = {
                label: label(item),
                value:
                  className === "MemberDetail" ? item.get("memberId") : item.id
              })
          );
          resolve(data);
        })
        .catch(err => {
          resolve([]);
        });
      });
    };

    if (input === "") {
      if (reduxCol.length == 0) {
        getValue()
        .then(data => {
          cb(null, { options: data });
        })
        .catch(data => {
          cb(null, { options: data });
        });
      } else {
        cb(null, { options: reduxCol });
      }
    } else {
      getValue()
      .then(data => {
        cb(null, { options: data });
      })
      .catch(data => {
        cb(null, { options: data });
      });
    }
  }

  accessible (actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

  render () {
    let {
      notif,
      actions
    } = this.props;

    let {
      errors,
      isOpenDatePicker,
      isUploadingCSVFile,
      showModalConfirmation,

      sendMode,
      sendModeOptions,
      userType,
      userTypeOptions,
      cardType,
      cardTypeOptions,
      ageBracket,
      gender,
      genderOptions,
      device,
      deviceOptions,
      screen,
      screenOptions,
      browser,
      browserOptions,
      specificUser,
      specificUserOptions,
      blacklistedUser,
      blacklistedUserOptions,

      subject,
      url,
    	message,
      scheduleDateTimeNotif,

      isSendNow,
      isSending,
      notifCount,
      notifCountWithSchedule,
      notifCountPending
    } = notif;

    let {
      setValue
    } = actions;

    const createSliderWithTooltip = Slider.createSliderWithTooltip;
    const Range = createSliderWithTooltip(Slider.Range);
    const Handle = Slider.Handle;

    const toolTipNotificationHistory = (
		  <TooltipB id="notifHistory" style={{ fontSize: '20px'}}>
				{notifCount}
		  </TooltipB>
		);

		const toolTipScheduledNotification = (
		  <TooltipB id="notifSchedule" style={{ fontSize: '20px'}}>
				{notifCountWithSchedule}
		  </TooltipB>
		);

    const toolTipPendingNotification = (
		  <TooltipB id="notifPending" style={{ fontSize: '20px'}}>
				{notifCountPending}
		  </TooltipB>
		);

    const space = {
			paddingTop: '10px',
			paddingBottom: '10px'
		};

    const colorRed = {
			color: 'red'
		}

		const colorBlack = {
			color: 'black'
		}

    const loadingState = {
			padding: '5px',
			display: isSending
				? 'inline-block'
				: 'none',
      color: "white"
		}

    const specificUserStyle = {
			display: ((userType)
				? ((userType.value === 'MEMBER')
					? 'block'
					: 'none')
				: 'none'),
			...space
		};

    let isCardTypeFieldDisabled = specificUser.length !== 0 ? true : false,
        isSpecificUserFieldDisabled = cardType.length !== 0 ? true : false;

    let popupMessage = (component, message) => {
      return (
        <OverlayTrigger
          placement="top"
          id={message}
          overlay={
            <Popover>
              {message}
            </Popover>
          }
          >
          {component}
        </OverlayTrigger>
      );
    };

    return (
      <div>
        <Row
          style={{
  					margin: '0'
  				}}
          >
          <Col
            md={4}
            >
            <Panel>
              <Panel.Body>
                <OverlayTrigger
                  placement="top"
                  overlay={toolTipPendingNotification}
                  >
                  <Badge
                    className={style.circleRed}
                    >
                    {(notifCountPending > 99) ? (
                      '99+'
                    ) : (
                      notifCountPending
                    )}
                  </Badge>
                </OverlayTrigger>
                <Link
                  to="/notificationHistory"
                  style={{ color: 'black' }}
                  >
                  PENDING NOTIFICATION
                </Link>
              </Panel.Body>
            </Panel>
          </Col>
          <Col
            md={4}
            >
            <Panel>
              <Panel.Body>
                <OverlayTrigger
                  placement="top"
                  overlay={toolTipNotificationHistory}
                  >
                  <Badge
                    className={style.circleBlue}
                    >
                    {(notifCount > 99) ? (
                      '99+'
                    ) : (
                      notifCount
                    )}
                  </Badge>
                </OverlayTrigger>
                <Link
                  to="/notificationHistory"
                  style={{ color: 'black' }}
                  >
                  NOTIFICATION HISTORY
                </Link>
              </Panel.Body>
            </Panel>
          </Col>
          <Col
            md={4}
            >
            <Panel>
              <Panel.Body>
                <OverlayTrigger
                  placement="top"
                  overlay={toolTipScheduledNotification}
                  >
                  <Badge
                    className={style.circleOrange}
                    >
                    {(notifCountWithSchedule > 99) ? (
                      '99+'
                    ) : (
                      notifCountWithSchedule
                    )}
                  </Badge>
                </OverlayTrigger>
                <Link
                  to="/scheduledNotification"
                  style={{ color: 'black' }}
                  >
									SCHEDULED NOTIFICATION
								</Link>
              </Panel.Body>
            </Panel>
          </Col>
        </Row>
        <Row
          style={{
  					margin: 0
  				}}
          >
          <Panel>
            <Panel.Heading
              style={{
  							backgroundColor: '#D1282F',
  							color: 'white'
  						}}
              >
              <h4>PUSH NOTIFICATION</h4>
            </Panel.Heading>
            <Panel.Body
              style={{
							padding: '30px 50px 30px 50px'
  						}}
              >
              <Row>
                <Col md={6}>
                  <h4>Mobile Users</h4>
                  <Row style={space}>
                    <Col md={4}>Send Mode</Col>
                    <Col md={8}>
                      <Select
                        clearable={false}
                        value={sendMode}
                        options={sendModeOptions}
                        onChange={e => {
                          let stateToUpdate = {
                            sendMode: e
                          };

                          if (e.value.toUpperCase() === "TEST") {
                            stateToUpdate.userType = {
                              value: "MEMBER",
                              label: "MEMBER"
                            };
                          } else {
                            stateToUpdate.userType = {
                          		value: 'ALL',
                          		label: 'ALL'
                          	};

                            stateToUpdate.cardType = [];
                            stateToUpdate.specificUser = [];
                          }

                          setValue(NOTIFICATION_SET_VALUE, stateToUpdate);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row style={space}>
                    <Col md={4}>User Type</Col>
                    <Col md={8}>
                      <Select
                        clearable={false}
                        disabled={sendMode.value.toUpperCase() === "TEST"}
                        value={userType}
                        options={userTypeOptions}
                        onChange={e => {
                          let stateToUpdate = {
                            userType: e
                          };

                          if (e.value !== "MEMBER") {
                            stateToUpdate.cardType = [];
                            stateToUpdate.specificUser = [];
                          }

                          setValue(NOTIFICATION_SET_VALUE, stateToUpdate);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row
                    style={space}
                    style={{
                      display: userType ? (userType.value === "MEMBER" ? "" : "none") : "none"
                    }}
                    >
                    <Col md={4}>
                      Card Holder Type&nbsp;
                      {isCardTypeFieldDisabled ? (
                        popupMessage(
                          <i className="fa fa-info-circle"></i>,
                          "Specific User is already assigned"
                        )
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col md={8}>
                      <Select.Async
												placeholder="Select or Search..."
                        multi={true}
                        disabled={isCardTypeFieldDisabled}
												value={cardType}
												loadOptions={(input, callback) => this.loadOptions(input, callback, 'CardType', 'name', cardTypeOptions)}
												onChange={(e) => setValue(NOTIFICATION_SET_VALUE, "cardType", e)}
												/>
                    </Col>
                  </Row>
                  {/*
                    <Row style={space}>
  										<Col md={4}>Age Bracket</Col>
  										<Col md={8}>
                        <Range
                          min={18}
                          max={70}
                          defaultValue={ageBracket}
                          tipFormatter={value => `${value}`}
                          value={ageBracket}
                          trackStyle={[
                            {
                              backgroundColor: "#D1282F"
                            }
                          ]}
                          handleStyle={[
                            {
                              borderColor: "#D1282F"
                            }
                          ]}
                          onChange={value => {
                            setValue(
                              NOTIFICATION_SET_VALUE,
                              {
                                ageBracket: value
                              }
                            );
                          }}
                          />
                        <h6
                          style={{
                            display: "inline",
                            float: "left",
                            margin: "0"
                          }}
                          >
                          {ageBracket[0]}
                        </h6>
                        <h6
                        style={{
                          display: "inline",
                          float: "right",
                          margin: "0"
                        }}
                        >
                        {ageBracket[1]}
                      </h6>
                      </Col>
                    </Row>
                    <Row style={space}>
                      <Col md={4}>Gender</Col>
                      <Col md={8}>
                        <Selectfgender
                          value={gender}
                          options={genderOptions}
                          onChange={(e) => setValue(NOTIFICATION_SET_VALUE, "gender", e)}
                          />
                      </Col>
                    </Row>
                    */}
                  <Row style={space}>
                    <Col md={4}>Device Type</Col>
                    <Col md={8}>
                      <Select
                        clearable={false}
                        value={device}
                        options={deviceOptions}
                        onChange={e => setValue(NOTIFICATION_SET_VALUE, "device", e)}
                        />
                    </Col>
                  </Row>
                  <Row style={space}>
                    <Col md={4}>Screen</Col>
										<Col md={8}>
                      <Select.Async
                        placeholder="Select or Search..."
                        value={screen}
                        loadOptions={(input, callback) => this.loadOptions(input, callback, 'Screen', 'pageName', screenOptions)}
                        onChange={(e) => setValue(NOTIFICATION_SET_VALUE, 'screen', e)}
                        />
                    </Col>
                  </Row>
                	<Row style={space}>
                    <Col md={4}>Browser</Col>
                    <Col md={8}>
                      <Select
                        value={browser}
                        options={browserOptions}
                        onChange={value => {
                          let stateToUpdate = {
                            browser: value
                          };

                          if (!IS_VALID(value)) {
                            stateToUpdate.url = "";
                          }

                          setValue(NOTIFICATION_SET_VALUE, stateToUpdate);
                        }}
                        />
                    </Col>
                  </Row>
                </Col>
                <Col md={6}>
                  <h4>Push Notification Details</h4>
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <span style={colorRed}>*</span>
                        &nbsp; Subject
                        <FormControl
                          type="text"
                          placeholder="Enter Subject.."
                          value={subject}
                          onChange={(e) => setValue(NOTIFICATION_SET_VALUE, { subject: e.target.value })}
                          inputRef={e => (this.subject = e)}
                          style={colorBlack}
                        />
                        <p style={colorRed}>
                          <i>{typeof errors.subject !== "undefined" ? errors.subject : ""}</i>
                        </p>
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <span style={colorRed}>*</span>
                        &nbsp; Url Link
                        <FormControl
                          type="text"
                          placeholder="Enter Url.."
                          value={url}
                          onChange={(e) => setValue(NOTIFICATION_SET_VALUE, { url: e.target.value })}
                          inputRef={e => (this.url = e)}
                          style={colorBlack}
                          disabled={browser ? "" : "disabled"}
                        />
                        <p style={colorRed}>
                          <i>{typeof errors.url !== "undefined" ? errors.url : ""}</i>
                        </p>
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <span style={colorRed}>*</span>
                        &nbsp; Notification Message
                        <FormControl
                          componentClass="textarea"
                          placeholder="Enter Message.."
                          value={message}
                          onChange={(e) => setValue(NOTIFICATION_SET_VALUE, { message: e.target.value })}
                          inputRef={e => (this.message = e)}
                          style={colorBlack}
                        />
                        <p style={colorRed}>
                          <i>
                            <i>{typeof errors.message !== "undefined" ? errors.message : ""}</i>
                          </i>
                        </p>
                      </FormGroup>
                      <FormGroup>
                        <Radio
                          name="pushtype"
                          inline
                          checked={isSendNow}
                          onChange={e => setValue(NOTIFICATION_SET_VALUE, "isSendNow", true)}
                        >
                          Send Push
                        </Radio>
                      </FormGroup>
                      <FormGroup>
                        <Radio
                          name="pushtype"
                          inline
                          checked={!isSendNow}
                          onChange={e => setValue(NOTIFICATION_SET_VALUE, "isSendNow", false)}
                        >
                          Schedule Push Notification
                        </Radio>
                      </FormGroup>
                      <FormGroup>
                        <InputGroup>
                          <DateTime
                            dateFormat="MMM DD, YYYY"
                            timeFormat="hh:mm A"
                            value={scheduleDateTimeNotif}
                            inputProps={{
                              disabled: isSendNow
                            }}
                            disableOnClickOutside={true}
                            open={isOpenDatePicker}
                            onChange={date => {
                              setValue(NOTIFICATION_SET_VALUE, { scheduleDateTimeNotif: date })
                            }}
                            ref={e => (this.dateTime = e)}
                            style={colorBlack}
                            isValidDate={current => {
                              return current.isAfter(moment().subtract(1, "day"));
                            }}
                          />
                          <InputGroup.Button>
                            <Button
                              disabled={isSendNow}
                              style={{
                                backgroundColor: "black",
                                paddingTop: "0",
                                paddingBottom: "0"
                              }}
                              onClick={() => {
                                setValue(NOTIFICATION_SET_VALUE, { isOpenDatePicker: !isOpenDatePicker });
                              }}
                            >
                              <img src={ic_calendar} height="32px" />
                            </Button>
                          </InputGroup.Button>
                        </InputGroup>
                        <p style={colorRed}>
                          <i>{typeof errors.scheduleDateTimeNotif !== "undefined" ? errors.scheduleDateTimeNotif : ""}</i>
                        </p>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                {IS_VALID(userType) && IS_VALID(userType.value) && userType.value === "MEMBER" ? (
                  <Col md={IS_VALID(specificUser) && specificUser.length > 10 ? 12 : 6}>
                    Specific Users: Total {specificUser ? specificUser.length : 0}&nbsp;
                    {isSpecificUserFieldDisabled ? (
                      popupMessage(
                        <i className="fa fa-info-circle"></i>,
                        "Card Type is already assigned."
                      )
                    ) : (
                      ""
                    )}
                    <Select.Async
                      placeholder="Select or Search..."
                      multi={true}
                      disabled={isSpecificUserFieldDisabled}
                      value={specificUser}
                      loadOptions={(input, callback) => this.loadOptions(input, callback, 'MemberDetail', ['memberId', 'name'], specificUserOptions)}
                      onChange={(e) => setValue(NOTIFICATION_SET_VALUE, 'specificUser', e)}
                      />
                    <Row
                      style={{
                        ...space
                      }}
                      >
                      <Col
                        md={IS_VALID(specificUser) && specificUser.length > 10 ? 6 : 12}
                        mdOffset={IS_VALID(specificUser) && specificUser.length > 10 ? 3 : null}
                        >
                        <Button
                          style={{ width: "100%" }}
                          disabled={isUploadingCSVFile || isSpecificUserFieldDisabled}
                          onClick={() => {
                            if (!isSpecificUserFieldDisabled) {
                              this.dropzoneRef.name = "specificUser";
                              this.dropzoneRef.open();
                            }
                          }}
                          >
                          {isUploadingCSVFile ? (
                            <i className="fa fa-spinner fa-spin"></i>
                          ) : (
                            "UPLOAD SPECIFIC USER CSV"
                          )}
                        </Button>
                        <Dropzone
                          accept=".csv, text/csv"
                          style={{ display: "none" }}
                          multiple={false}
                          ref={(ref) => { this.dropzoneRef = ref; }}
                          onDropAccepted={(acceptedArray) => {
                            this.uploadSpecificUserCSVFile(acceptedArray[0], this.dropzoneRef.name);
                          }}
                          />
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  ""
                )}
                <Col
                  md={IS_VALID(blacklistedUser) && blacklistedUser.length > 10 ? 12 : 6}
                  >
                  Excluded Users: Total {blacklistedUser ? blacklistedUser.length : 0}
                  <Select.Async
                    placeholder="Select or Search..."
                    multi={true}
                    value={blacklistedUser}
                    loadOptions={(input, callback) => this.loadOptions(input, callback, 'MemberDetail', ['memberId', 'name'], blacklistedUserOptions)}
                    onChange={(e) => setValue(NOTIFICATION_SET_VALUE, 'blacklistedUser', e)}
                    />
                  <Row
                    style={{
                      ...space
                    }}
                    >
                    <Col
                      md={IS_VALID(blacklistedUser) && blacklistedUser.length > 10 ? 6 : 12}
                      mdOffset={IS_VALID(blacklistedUser) && blacklistedUser.length > 10 ? 3 : null}
                      >
                      <Button
                        style={{ width: "100%" }}
                        disabled={isUploadingCSVFile}
                        onClick={() => {
                          this.dropzoneRef.name = "blacklistedUser";
                          this.dropzoneRef.open();
                        }}
                        >
                        {isUploadingCSVFile ? (
                          <i className="fa fa-spinner fa-spin"></i>
                        ) : (
                          "UPLOAD EXCLUDED USER CSV"
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br/>
              <Row>
                <Col
                  md={6}
                  mdOffset={3}
                  >
                  <FormGroup style={{ display: this.accessible("SAVE DRAFT") }}>
                    <Col md={12}>
                      <Button
                        disabled={isSending || isUploadingCSVFile}
                        style={{
                          backgroundColor: "black",
                          color: "white",
                          width: "100%"
                        }}
                        onClick={() => {
                          if (this.accessible("SAVE DRAFT") === "") {
                            this.submitPush(true);
                          }
                        }}
                      >
                        <i style={loadingState} className="fa fa-spinner fa-spin" />SAVE DRAFT
                      </Button>
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
            </Panel.Body>
          </Panel>
        </Row>
        <Modal
          show={showModalConfirmation}
          onHide={() => {
            if (!isSending || !isUploadingCSVFile) {
              setValue(
                NOTIFICATION_SET_VALUE,
                {
                  showModalConfirmation: false
                }
              );
            }
          }}
          >
          <Modal.Header closeButton>
            <h4>Push Notification</h4>
          </Modal.Header>
          <Modal.Body>
            <Table
              bordered
              responsive
              style={{
                tableLayout: "fixed"
              }}
              >
              <tbody>
                <tr>
                  <td>
                    <b>Send Mode</b>
                  </td>
                  <td>{IS_VALID(sendMode) && IS_VALID(sendMode.label) ? sendMode.label : ""}</td>
                </tr>
                <tr>
                  <td>
                    <b>User Type</b>
                  </td>
                  <td>{IS_VALID(userType) && IS_VALID(userType.label) ? userType.label : ""}</td>
                </tr>
                {userType.value.toUpperCase() === "MEMBER" ? (
                  <tr>
                    <td>
                      <b>Card Holder Type</b>
                    </td>
                    <td>{IS_VALID(cardType) && Array.isArray(cardType) ? cardType.map(({ label }) => label).join(", ") : ""}</td>
                  </tr>
                ) : (
                  ""
                )}
                <tr>
                  <td>
                    <b>Device Type</b>
                  </td>
                  <td>{IS_VALID(device) && IS_VALID(device.label) ? device.label : ""}</td>
                </tr>
                <tr>
                  <td>
                    <b>Screen</b>
                  </td>
                  <td>{IS_VALID(screen) && IS_VALID(screen.label) ? screen.label : ""}</td>
                </tr>
                <tr>
                  <td>
                    <b>Browser</b>
                  </td>
                  <td>{IS_VALID(browser) && IS_VALID(browser.label) ? browser.label : ""}</td>
                </tr>
                <tr>
                  <td>
                    <b>Specific Users</b>
                  </td>
                  <td>
                    {IS_VALID(specificUser) && Array.isArray(specificUser) ? (
                      specificUser.length === 0 ? "" : specificUser.map(({ label }) => label || "").join(", ")
                    ) : ""}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Excluded Users</b>
                  </td>
                  <td>
                    {IS_VALID(blacklistedUser) && Array.isArray(blacklistedUser) ? (
                      blacklistedUser.length === 0 ? "" : blacklistedUser.map(({ label }) => label || "").join(", ")
                    ) : ""}
                  </td>
                </tr>
              </tbody>
            </Table>
            <br/>
            <Table
              bordered
              responsive
              style={{
                tableLayout: "fixed"
              }}
              >
              <tbody>
                <tr>
                  <td>
                    <b>Subject</b>
                  </td>
                  <td>
                    <p>{subject}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>URL</b>
                  </td>
                  <td>
                    <p>{url}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Message</b>
                  </td>
                  <td>
                    <p>{message}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>Schedule</b>
                  </td>
                  <td>
                    <p>{isSendNow ? "NOW" : moment(scheduleDateTimeNotif).format("MMM DD, YYYY hh:mm A")}</p>
                    <p style={colorRed}>
                      <i>{typeof errors.scheduleDateTimeNotif !== "undefined" ? errors.scheduleDateTimeNotif : ""}</i>
                    </p>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            {this.accessible("SAVE DRAFT") === "" ? (
              <Button
                className="btn-primary"
                onClick={() => {
                  this.submitPush();
                }}
                >
                <i style={loadingState} className="fa fa-spinner fa-spin" /> SAVE DRAFT
              </Button>
            ) : (
              ""
            )}
            <Button
              disabled={isSending || isUploadingCSVFile}
              onClick={() => {
                if (!isSending || !isUploadingCSVFile) {
                  setValue(
                    NOTIFICATION_SET_VALUE,
                    {
                      showModalConfirmation: false
                    }
                  );
                }
              }}
              >
              CLOSE
            </Button>
          </Modal.Footer>
        </Modal>
        <ToastContainer />
      </div>
    );
  }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

function mapStateToProps (state) {
  let {
    notif,
    accessjson
  } = state;

  return {
    notif,
    accessjson
  };
}

function mapDispatchToProps (dispatch) {
  const actions = {
    setValue: generics.setValue,
    isSaving: generics.isSaving
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Notification);



// WEBPACK FOOTER //
// ./components/Notification/index.js